<template>
  <div v-if="userLoaded">
    <navigation :links="links" :name="currentUser.name" @sign-out="signOut"></navigation>
    <main v-if="isDashboard && currentUser.approved" class="dashboard user-dash">
      <div class="container-fluid container-fluid--max">
        <notification></notification>
        <h1 class="d-none">Tableau de bord</h1>
        <section class="user-dash__opes card">
          <div class="card-body mx-lg-4">
            <h2 class="heading-secondary">Vos interventions en attente</h2>
            <div class="card my-3" v-for="(inter, i) in runningInter" :key="'running-' + i">
              <div class="card-body mx-lg-3">
                <InterventionHeader :intervention="inter" />
              </div>
            </div>
            <div class="text-center pt-1" v-if="enableMoreRunning">
              <router-link :to="{ name: 'interventions', hash: '#opesRunning' }" class="btn thin px-md-5" :class="'btn-outline-' + $mainColor">
                Voir plus
              </router-link>
            </div>
            <h2 class="heading-secondary">Vos interventions réalisées</h2>
            <div class="card my-3" v-for="(inter, i) in realizedInter" :key="'realized-' + i">
              <div class="card-body mx-lg-3">
                <InterventionHeader :intervention="inter" />
              </div>
            </div>
            <div class="text-center pt-1" v-if="enableMoreRealized">
              <router-link :to="{ name: 'interventions', hash: '#opesRealized' }" class="btn thin px-md-5" :class="'btn-outline-' + $mainColor">
                Voir plus
              </router-link>
            </div>
            <h2 class="heading-secondary">Vos interventions clôturées</h2>
            <div class="card my-3" :class="{ 'ope-card--closed': inter.resolved_at }" v-for="(inter, i) in resolvedInter" :key="'resolved-' + i">
              <div class="card-body mx-lg-3">
                <InterventionHeader :intervention="inter" />
              </div>
            </div>
            <div class="text-center pt-1" v-if="enableMoreResolved">
              <router-link :to="{ name: 'interventions', hash: '#opesResolved' }" class="btn thin px-md-5" :class="'btn-outline-' + $mainColor">
                Voir plus
              </router-link>
            </div>
          </div>
        </section>
        <Documents />
      </div>
    </main>
    <PresignFormation
      v-else-if="isDashboard && !currentUser.approved"
      :key="componentKey"
      @subscribe="subscribe" />
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/layout/Navigation'
import InterventionHeader from './interventions/InterventionHeader'
import Documents from './interventions/Documents'
import PresignFormation from './PresignFormation'
import { mapState, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'Dashboard',
  components: {
    Navigation,
    InterventionHeader,
    Documents,
    PresignFormation
  },
  data () {
    return {
      runningInter: [],
      resolvedInter: [],
      componentKey: 0
    }
  },
  computed: {
    ...mapState(['userLoaded', 'currentUser', 'userAuth', 'interventions']),
    ...mapGetters({ interventions: `${store.$appName}/interventions` }),
    links () {
      return [
        {
          title: this.currentUser.approved ? 'Tableau de bord' : 'Formation',
          pathname: 'userDashboard',
          name: 'userDashboard'
        },
        {
          title: 'Mes informations',
          pathname: 'userProfile',
          name: 'userProfile'
        },
        {
          title: 'Contact',
          pathname: 'userContact',
          name: 'contact'
        }
      ]
    },
    isDashboard () {
      return this.$route.name === 'userDashboard'
    },
    enableMoreRunning () {
      return (this.interventions.running.length > 3)
    },
    enableMoreRealized () {
      return (this.interventions.realized.length > 3)
    },
    enableMoreResolved () {
      return (this.interventions.resolved.length > 3)
    }
  },
  created () {
    this.runningInter = _.take(this.interventions.running, 3)
    this.realizedInter = _.take(this.interventions.realized, 3)
    this.resolvedInter = _.take(this.interventions.resolved, 3)

    let approvedLinks = [
      {
        title: 'Mes interventions',
        pathname: 'interventions',
        name: 'interventions'
      },
      {
        title: 'Formations',
        pathname: 'trainings',
        name: 'trainings'
      }
    ]
    if (this.currentUser.approved) {
      this.links.splice(1, 0, approvedLinks[0])
      this.links.splice(3, 0, approvedLinks[1])
    }
  },
  methods: {
    signOut () {
      this.$store.dispatch('signOut', {
        type: 'user',
        router: this.$router
      })
    },
    subscribe (param) {
      this.$http.patch('/user_auth', param, {
        headers: {
          ...this.userAuth
        }
      }).then(resp => {
        store.commit('SET_CURRENT_USER', { ...resp.data.data, type: 'user' })
        this.componentKey += 1
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
